<template>
    <div class="slider-item">
        <question :text="$t(item.text)" />
        <div class="slider-item__slider mb-md-4">
            <slider
                :range="sliderRange"
                @change="handleChange"
                :start="start"
                :labelMin="$t(item.text + '_MIN')"
                :labelMid="$t(item.text + '_MID')"
                :labelMax="$t(item.text + '_MAX')"
                :showRange="sliderConfig.showRange"
                :showTooltip="sliderConfig.showTooltip"
                :midMarker="sliderConfig.showMidmarker"
            />
        </div>
    </div>
</template>

<script>
import slider from '@/components/inputs/slider'
import question from '@/components/ui/question'
import { SHOW_MIDMARKER, SHOW_TOOLTIP, SHOW_RANGE, SLIDER_START } from '@/constants/items'

export default {
  name: 'sliderItem',
  components: {
    slider,
    question,
  },
  props: {
    item: {
        type: Object
    },
    itemProperties: {
        type: Object
    },
  },
  computed: {
    sliderRange() {
        return [this.item.scaleMin, this.item.scale];
    },
    sliderConfig() {
        return {
            start: this.itemProperties.getProperty(SLIDER_START),
            showRange: this.propToBool(this.itemProperties.getProperty(SHOW_RANGE)),
            showTooltip: this.propToBool(this.itemProperties.getProperty(SHOW_TOOLTIP)),
            showMidmarker: this.propToBool(this.itemProperties.getProperty(SHOW_MIDMARKER)),
        }
    },
    start() {
        return this.itemProperties.getProperty(SLIDER_START)
    },
  },
  methods: {
      propToBool(str) {
          if(str === 'false') {
            return false
          }
          return true
      },
      handleChange(result) {
          this.$emit('answer', { result })
      }
  }
};
</script>
<style lang="scss">
    .slider-item__slider {
        width: 95%;
        margin: 0 auto;
    }
</style>